import "./AppInputV2.scss";

import React, { forwardRef, useMemo, useState } from "react";

import Form from "react-bootstrap/Form";

const AppInputV2 = forwardRef(function AppInputV2(
  {
    type = "text",
    label,
    placeholder,

    isRequired = false,
    value,
    onChange,
    onBlur,
    name,

    errors = {},
    touched = {},

    disabled = false,
    readOnly = false,
    onClick,

    leftIcon,
    rightIcon,

    formText,
    maxLength,
    showCounter = false,

    backgroundColor,
    className = "",
    mask, // ✅ agora recebe a máscara
  },
  inputRef
) {
  const [showPassword, setShowPassword] = useState(false);

  const hasError = !!errors?.[name] && !!touched?.[name];
  const isPassword = type === "password";
  const resolvedType = isPassword ? (showPassword ? "text" : "password") : type;

  const counterText = useMemo(() => {
    if (!showCounter || !maxLength) return null;
    const len = (value ?? "").length;
    return `${len}/${maxLength}`;
  }, [value, showCounter, maxLength]);

  const setRefs = (node) => {
    if (typeof mask === "function") {
      mask(node);
    } else if (mask && typeof mask === "object") {
      mask.current = node;
    }

    if (typeof inputRef === "function") {
      inputRef(node);
    } else if (inputRef && typeof inputRef === "object") {
      inputRef.current = node;
    }
  };

  return (
    <div className={`hallapp-inputv2 ${className} ${disabled ? "is-disabled" : ""} ${hasError ? "is-error" : ""}`}>
      {label && (
        <div className="hallapp-inputv2__label">
          <span>{label}</span>
          {isRequired && <span className="hallapp-inputv2__required"> *(obrigatório)</span>}
        </div>
      )}

      <div
        className={`hallapp-inputv2__wrap ${readOnly ? "is-readonly" : ""}`}
        style={backgroundColor ? { backgroundColor } : undefined}
        onClick={onClick}
        role="presentation"
      >
        {leftIcon && <div className="hallapp-inputv2__iconLeft">{leftIcon}</div>}

        <Form.Control
          ref={setRefs} // ✅ aplica máscara + forwardRef
          name={name}
          type={resolvedType}
          value={value ?? ""}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          readOnly={readOnly}
          placeholder={placeholder || label}
          maxLength={maxLength}
          className="hallapp-inputv2__control"
          autoComplete="off"
        />

        {isPassword ? (
          <button
            type="button"
            className="hallapp-inputv2__iconRightBtn"
            onClick={() => setShowPassword((s) => !s)}
            tabIndex={-1}
            aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
            disabled={disabled}
          >
            <span className="hallapp-inputv2__rightEmoji">{showPassword ? "🙈" : "👁️"}</span>
          </button>
        ) : (
          rightIcon && <div className="hallapp-inputv2__iconRight">{rightIcon}</div>
        )}
      </div>

      <div className="hallapp-inputv2__meta">
        <div className="hallapp-inputv2__leftMeta">
          {hasError ? (
            <div className="hallapp-inputv2__error">{errors?.[name]}</div>
          ) : formText ? (
            <div className="hallapp-inputv2__help">{formText}</div>
          ) : null}
        </div>

        {counterText ? <div className="hallapp-inputv2__counter">{counterText}</div> : null}
      </div>
    </div>
  );
});

export default AppInputV2;